// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SP5wV","curtain":"_1bJrm","dropdown":"_2YJsM","active":"_1X88k","left":"_2BW9D","right":"_3q4_w","trigger":"_1NqV5"};